<template>
  <div class="month-selector">
    <div v-for="(months, key, index) in seasons" :key="index" class="month-selector__season" :class="`month-selector__seasons--${yearsList.length}`">
      <h5>Sezon {{ key }}</h5>
      <div class="month-selector__list">
        <div v-for="(month, index) in months" :key="index"
          @click="monthSelected(month)"
          @mouseenter="$emit('hover', month)"
          @mouseleave="$emit('clearHover')"
          :class="{
            'month-selector__month': true,
            'month-selector__month--selected': isSelected(month),
          }">
          {{ formattedMonth(month) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy'
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    validDates: {
      required: true,
      type: Object, // Moment.range
    },
    selected: {
      required: true,
      type: Object, // Moment.range
    },
  },
})
export default class MonthSelector extends Vue {
  yearsList = []

  get years () {
    let temp = this.validDates.start
    while (this.validDates.end >= temp) {
      this.yearsList = uniqBy([ ...this.yearsList, moment(temp).year() ])
      temp = moment(temp).add(1, 'month')
    }

    return this.yearsList
  }

  get seasons () {
    const hiddenSeasonIds = [ 10, 11, 0, 1, 2 ] //From november to march, grecos doesn't offer trips in those months
    return this.years.reduce((seasons, item) => {
      let temp = this.validDates.start
      while (this.validDates.end >= temp) {
        const momentTemp = moment(temp)
        const isHiddenSeason = hiddenSeasonIds.includes(momentTemp.month())

        if (momentTemp.year() === item && !isHiddenSeason) {
          seasons[item] = [ ...seasons[item] || {}, { ...temp } ]
        }

        temp = momentTemp.add(1, 'month')
      }
      return seasons
    }, {})
  }

  isSelected (month) {
    return moment(month).isSame(moment(this.selected.start), 'month')
  }

  formattedMonth (month) {
    return moment(month).format('MMMM')
  }

  monthSelected (month) {
    log.debug('Month.monthSelected', moment(month).format('YYYY-MM-DD'))
    this.$emit('click', month)
  }
}
</script>

<style lang="scss" scoped>
.month-selector {
  display: flex;
  justify-content: space-between;
  text-align: center;
  margin-top: 13px;

  h5 {
    text-transform: uppercase;
  }

  &__list {
    display: grid;
    width: 384px;
    margin: 17px auto 0;
  }

  &__month {
    text-transform: uppercase;
    border: 1px solid #ADADAD;
    color: #005CA9;
    background-color: transparent;
    font-size: 12px;
    padding: 11px 0 9px;
    cursor: pointer;

    &:hover:not(&--selected) {
      background-color: #81CCFF;
      border-color: #81CCFF;
    }
  }

  &__month--selected {
    background-color: #009FEA;
    border-color: #009FEA;
    color: #fff;
  }

  &__season {
    width: 100%;
  }

  &__seasons--1 .month-selector__list {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 6px;
    grid-row-gap: 6px;
  }

  &__seasons--2 .month-selector__list {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 3px;
    grid-row-gap: 3px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/calendar/MonthSelector.vue